<template lang="pug">
.event-preview-modal
  b-modal(ref="modal" size="lg" no-close-on-backdrop no-close-on-esc hide-footer)
    div(slot="modal-title")

    .event-preview(v-if="event")
      EventPreview.d-flex.justify-content-center(
        :date="event.date"
        :timeFrom="_timeFrom"
        :timeTo="_timeTo"
        :place="event.place"
        :title="event.title"
        :holdType="event.holdType"
        :needReply="event.needReply"
        :replyDeadline="event.replyDeadline"
        :description="event.description"
        :imageUrl="imageUrl")
  </template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { EventGetModel } from "@/commons/services/Events";
import EventPreview from "@/pc/basics/EventPreview.vue";

/**
 * ### イベントプレビューモーダル
 */
@Component({
  components: {
    EventPreview
  }
})
export default class EventPreviewModal extends Vue {
  /** 画像URL */
  @Prop({
    default: () => {
      return "";
    }
  })
  imageUrl!: string;

  /** イベント */
  @Prop({
    default: () => {
      return undefined;
    }
  })
  event!: EventGetModel;

  /**
   * モーダル表示
   */
  public show(): void {
    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }

    return;
  }

  get _timeFrom(): string {
    if (this.event.timeFrom) {
      return this.$dateUtil.convertTimepickerTime(this.event.timeFrom);
    } else {
      return "";
    }
  }

  get _timeTo(): string {
    if (this.event.timeTo) {
      return this.$dateUtil.convertTimepickerTime(this.event.timeTo);
    } else {
      return "";
    }
  }
}
</script>
